import { debounceTime, fromEvent, map, Observable, shareReplay, tap } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { ViewportScroller } from '@angular/common';
import { debounce } from 'lodash';
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {
  isNotTop: Observable<boolean>;
  constructor(private viewportScroller: ViewportScroller) {

    // this.getViewportScrollPosition = this.vr.getViewportScrollPosition();
    this.isNotTop = fromEvent(document, 'scroll').pipe(
      debounceTime(10),
      map(a => this.viewportScroller.getScrollPosition()[1]),
      map(a => a > 0)
    )



    // this.getViewportScrollPosition = this.vr.change(200).pipe(
    //   tap(a => console.log(a)),
    //   map(a => this.vr.getViewportScrollPosition()),
    //   shareReplay()
    // )

    // this.viewportScroller.getScrollPosition([0, 0]);

  }

  changeLang() {
  }
  ngOnInit(): void {
  }

  gotop() {

    this.viewportScroller.scrollToPosition([0, 0]);

  }

}
